import { render, staticRenderFns } from "./ComplaintsFilterDialog.vue?vue&type=template&id=c4b4ba20&scoped=true&"
import script from "./ComplaintsFilterDialog.vue?vue&type=script&lang=js&"
export * from "./ComplaintsFilterDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsFilterDialog.vue?vue&type=style&index=0&id=c4b4ba20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b4ba20",
  null
  
)

export default component.exports